exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/core-js/library/modules/_wks-ext.js
 ** module id = 144
 ** module chunks = 0
 **/